export default {
  warning:
    'Questo punto vendita non è associato a un marchio. Per il corretto funzionamento del sistema deve appartenerne a uno. Aggiungi questo punto vendita a un marchio.',
  cta: 'Vai ai marchi',
};
